import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Urls } from "../../../utils/constant";
import Joi from "joi";

import { useSnackbar } from "notistack";

import { useApi } from "../apiCall/useApi";
import { getUserToken } from "../../selectors/Authentication/appState.selector";
import {
  changeLoggedInStatus,
  setUserToken,
} from "../../reducers/Authentication/appState.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { resetAppState } from "../../reducers/Authentication/appState.reducer";
import { resetDashboardState } from "../../reducers/ProjectDashboard/dashboard.reducer";
import useGlobalPageLoader from "../Common/PageLoader/useGlobalPageLoader";
import { useNavigate } from "react-router-dom";

export const authSchema = Joi.object({
  email_id: Joi.string()
    .email({ tlds: { allow: ["com"] } })
    .required()
    .messages({
      "string.empty": "Email Is Required",
      "string.email": "Enter a Valid Email Address",
    }),
  password: Joi.string().required().messages({
    "string.empty": "Password is required.",
  }),
});

export function useAuth() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loader] = useGlobalPageLoader();
  const token = useSelector(getUserToken);

  const logout = useCallback(async () => {
    try {
      dispatch(resetAppState());
      dispatch(resetDashboardState());
    } catch (err) {
      console.log("error", err);
    }
  }, []);

  const login = useCallback(
    async ({ email_id, password }) => {
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.login(),
          data: {
            email_id: email_id,
            password: password,
            device_id: null,
            notification_id: null,
          },
        });

        if (data.status === 200) {
          dispatch(
            changeLoggedInStatus({
              isLoggedIn: true,
              userToken: data.token,
              user_id: data.id,
              user_group_id: data.user_group,
              user_name: data.full_name,
              sysAdmin: data.sys_admin,
              email: data.email,
              doctorId: data.doctor_id,
            })
          );
          dispatch(setUserToken(data.token));
          enqueueSnackbar("Login Successfully.", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Invalid Credentials.", {
            variant: "error",
          });
        }

        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
      }
    },
    // eslint-disable-next-line
    [token, logout]
  );

  return {
    login,
    logout,
    loader,
  };
}
